module.exports = __webpack_public_path__ + "media/opening.c776f71f.mp3";